// @ts-nocheck
import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  Button,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";
import DotPagination from "../../../components/DotPagination/DotPagination";
import {
  deleteAllContentFilesAction,
  deleteAllScheduleFilesAction,
  deleteContentResourcesAction,
  deleteScheduleResourcesAction,
  fetchContentResourcesAction,
  fetchScheduleResourcesAction,
  uploadContentResourcesAction,
  uploadScheduleResourcesAction,
} from "../../../store/actions/eventRequestDetails";

// assets
import pptLogo from "../../../assets/logos/ppt.svg";
import videoLogo from "../../../assets/logos/video.svg";
import excelLogo from "../../../assets/logos/excel.svg";
import musicLogo from "../../../assets/logos/music.svg";
import pdfLogo from "../../../assets/logos/pdf.svg";
import otherLogo from "../../../assets/logos/other.svg";
import docsLogo from "../../../assets/logos/docs.svg";
import imageLogo from "../../../assets/logos/image.png";
import { UploadFile } from "@mui/icons-material";
import DeletePink from "../../../assets/images/Delete-pink.svg";
import { Download } from "@mui/icons-material";
import FileAccordion from "../../../components/Accordions/FileAccordions";
import { alertDialogAciton } from "../../../store/actions/auth";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import { CustomDialog } from "../../../components/Dialog/CustomDialog";
import { DeleteForever } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import RowsPerPageDropdown from "../../../components/Custom/Pagination/RowsPerPageDropdown";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { rowsPerPageInit } from "../../../utils/constants/paginationConstants";

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    // width: "100%",
    // display: "flex",
    // justifyContent: "space-between",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // width: "100%",
    // display: "flex",
    // justifyContent: "space-between",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  // width: "100%",
  // display: "flex",
  // justifyContent: "space-between",
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      key={index}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function allyProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function uploadAllow(userRole) {
  if (userRole === USER_ROLES.CLIENT) {
    return true;
  } else if (userRole === USER_ROLES.ADMIN) {
    return true;
  } else if (userRole === USER_ROLES.SUPERADMIN) {
    return true;
  } else {
    return false;
  }
}

export default function EventResourceTab({ eventId }) {
  const [value, setValue] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [showModal, setShowModal] = React.useState({
    status: false,
    previousValues: null,
    updatedValues: null,
    description: null,
  });

  const { eventInfo, eventLogs } = useSelector(
    (state) => state.eventRequestDetails,
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      fetchScheduleResourcesAction({
        payload: {
          eventId: eventId,
        },
      }),
    );
    dispatch(
      fetchContentResourcesAction({
        payload: {
          eventId: eventId,
        },
      }),
    );
  }, []);

  // tab change handler
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        flex: "1 0 auto",
      }}
    >
      {/* show two tabs of schedule and content */}

      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="fullWidth"
            TabScrollButtonProps={{
              style: {
                color: `${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
              },
            }}
            scrollButtons="auto"
            sx={{
              border: "1px solid #D175B6",
              overflow: "hidden",
              display: "inline-flex",
              justifyContent: "space-between",
              width: "100%",
              borderRadius: "8px",
              "& button": {
                textTransform: "none",
                color: "#D175B6",
                width: "50%",
                "&.Mui-selected": {
                  backgroundColor: "#D175B6",
                },
                "& span": {
                  display: "none",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab label="Schedule/Run of show" {...allyProps(0)} />
            <Tab label="Content" {...allyProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel
          value={value}
          index={0}
          sx={{
            padding: "0",
          }}
        >
          {/* event schedules */}
          <ScheduleContent eventInfo={eventInfo} />
        </CustomTabPanel>

        <CustomTabPanel
          value={value}
          index={1}
          sx={{
            padding: "0",
          }}
        >
          {/* evnet contents */}
          <ContentTab />
        </CustomTabPanel>
      </Box>
    </Box>
  );
}

EventResourceTab.propTypes = {
  eventId: PropTypes.string,
};

const getLogoForFileType = (type) => {
  switch (type) {
    case "ppt":
      return pptLogo;
    case "video":
      return videoLogo;
    case "music":
      return musicLogo;
    case "excel":
      return excelLogo;
    case "other":
      return otherLogo;
    case "pdf":
      return pdfLogo;
    case "docx":
      return docsLogo;
    case "image":
      return imageLogo;
    default:
      return otherLogo;
  }
};

const getTitleForFileType = (type) => {
  switch (type) {
    case "ppt":
      return "Power Point Presentation";
    case "video":
      return "Video";
    case "music":
      return "Music";
    case "excel":
      return "Excel";
    case "pdf":
      return "PDF";
    case "docx":
      return "Document";
    case "image":
      return "Image";
    case "other":
      return "Other";
    default:
      return "Other";
  }
};

const ScheduleContent = ({ eventInfo }) => {
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageInit);
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [totalFiles, setTotalFiles] = React.useState(0);
  const [deleteFileModal, setDeleteFileModal] = React.useState({
    fileId: null,
    status: false,
  });
  const [deleteAllModal, setDeleteAllModal] = React.useState({
    status: false,
  });
  const { userRole } = useSelector((state) => state.auth);
  const { scheduleResources, scheduleLoading } = useSelector(
    (state) => state.eventRequestDetails,
  );
  const uploadFileRef = React.useRef(null);
  const dispatch = useDispatch();

  React.useEffect(() => {
    setRows(scheduleResources);
  }, [scheduleResources]);

  const uploadFileHandler = (e) => {
    // allow pdf, text and doc files
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "text/plain",
      "image/png",
      "image/jpeg",
    ];
    const files = Array.from(e.target.files);

    if (files?.length > 5) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Warning",
          message: "Please upload at most 5 files!",
        }),
      );
      return;
    }

    // Filter out invalid files and show alert if any invalid files are found
    const invalidFiles = files.filter(
      (file) => !allowedTypes.includes(file.type),
    );
    if (invalidFiles.length > 0) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Invalid File Type",
          message: "Please upload only image, excel, word, text and pdf files",
        }),
      );
      return; // Stop the function execution if there are invalid files
    }

    setTotalFiles(files.length);
    if (files.length === 0) return;

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    dispatch(
      uploadScheduleResourcesAction({
        payload: {
          formData,
          eventId: eventInfo?._id,
        },
        successCallback: () => {
          if (uploadFileRef.current) {
            uploadFileRef.current.value = "";
          }
        },
        failureCallback: (msg) => {
          if (uploadFileRef.current) {
            uploadFileRef.current.value = "";
          }
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to upload the file.",
            }),
          );
        },
      }),
    );
  };

  // NOTE: download button
  const handleDownloadClick = ({ downloadLink, fileName }) => {
    const anchor = document.createElement("a");
    anchor.href = downloadLink;
    anchor.download = fileName;
    anchor.target = "_blank";
    anchor.click();
  };

  const deleteFileHandler = (fileId) => {
    dispatch(
      deleteScheduleResourcesAction({
        payload: {
          eventId: eventInfo?._id,
          fileId,
        },
        successCallback: () => {
          setDeleteFileModal({ fileId: null, status: false });
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: "File deleted successfully",
            }),
          );
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: "Failed to delete file",
            }),
          );
        },
      }),
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        flex: "1 0 auto",
      }}
    >
      <Box
        sx={{
          border: "1px solid #D175B6",
          borderRadius: "8px",
          overflow: "hidden",
          position: "relative",
          minHeight: "100px",
          overflowY: "hidden",
        }}
      >
        {scheduleLoading ? (
          <LoadingOverlay open={scheduleLoading} />
        ) : (
          <TableContainer
            className="custom-scroll-design"
            sx={{ maxWidth: "100%" }}
          >
            <Table sx={{}} aria-label="sticky table" stickyHeader>
              <TableHead
                sx={{
                  backgroundColor: "#D175B6",
                }}
              >
                <TableRow
                  sx={{
                    "& th": {
                      padding: "13px 15px",
                      fontSize: "14px",
                      color: "#ffffff",
                      borderColor: "#D175B6",
                      background: "transparent",
                      "& span": {
                        color: "#ffffff !important",
                      },
                    },
                  }}
                >
                  <TableCell>Name</TableCell>

                  <TableCell
                    sx={{
                      textAlign: "right",
                    }}
                  >
                    {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
                      <Button
                        sx={{
                          padding: "4px 8px",
                          boxShadow:
                            " 0px 30px 80px 0px rgba(255, 0, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.6) inset !important",
                          position: "relative",
                          overflow: "hidden",
                          marginRight: "15px",
                        }}
                        startIcon={<DeleteForever />}
                        type="button"
                        onClick={() => {
                          setDeleteAllModal({ status: true });
                        }}
                      >
                        Delete all
                      </Button>
                    )}

                    {/* TODO: create a upload document button here */}
                    {uploadAllow(userRole) && (
                      <Button
                        sx={{
                          padding: "4px 8px",
                          boxShadow:
                            " 0px 30px 80px 0px rgba(255, 0, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.6) inset !important",
                          position: "relative",
                          overflow: "hidden",
                        }}
                        startIcon={<UploadFile />}
                        type="button"
                        onClick={() => {
                          uploadFileRef.current.click();
                        }}
                      >
                        upload file
                        <VisuallyHiddenInput
                          type="file"
                          multiple
                          ref={uploadFileRef}
                          onChange={uploadFileHandler}
                          max={5}
                        />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  "& td": {
                    borderColor: "#D175B6",
                    fontSize: "14px",
                    padding: "13px 15px",
                    color: "#ffffff",
                    "& p": {
                      fontSize: "14px",
                    },
                  },
                }}
              >
                {rows?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#ffffff",
                          textAlign: "center",
                        }}
                      >
                        No Files uploaded
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
                {rows?.map((row, index) => {
                  return (
                    <StyledTableRow key={row?._id}>
                      <StyledTableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <img
                            src={getLogoForFileType(row?.type)}
                            alt="file logo"
                            style={{ width: "40px", height: "40px" }}
                          />
                          <Typography>{row?.fileName}</Typography>
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          textAlign: "right",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <Typography>
                            Added: &nbsp;
                            {/* {formatDate(row?.uploadDate)} */}
                            {/* Added: 12 May, 2024 */}
                            {getUniversalDateTimeFormat({
                              dateTime: row?.uploadDate,
                            })}
                          </Typography>
                          {uploadAllow(userRole) && (
                            <>
                              {scheduleLoading ? (
                                <Typography>
                                  {totalFiles}{" "}
                                  {totalFiles > 1 ? "files" : "file"} uploading
                                </Typography>
                              ) : (
                                <Button
                                  size="small"
                                  variant="text"
                                  sx={{
                                    backgroundColor: "#fff",
                                    padding: "10px 10px",
                                    width: "auto",
                                    minWidth: "auto",
                                    ":hover": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                  onClick={() => {
                                    setDeleteFileModal({
                                      fileId: row?._id,
                                      status: true,
                                    });
                                  }}
                                >
                                  <img src={DeletePink} alt="" />
                                </Button>
                              )}
                            </>
                          )}
                          <Button
                            size="small"
                            variant="text"
                            sx={{
                              backgroundColor: "#fff",
                              padding: "10px 10px",
                              width: "auto",
                              minWidth: "auto",
                              ":hover": {
                                backgroundColor: "#fff",
                              },
                            }}
                            onClick={() => {
                              handleDownloadClick({
                                downloadLink: row?.url,
                                fileName: row?.fileName,
                              });
                            }}
                          >
                            {/* <img src={DeletePink} alt="" /> */}
                            <Download
                              sx={{
                                fontSize: "20px",
                              }}
                            />
                          </Button>
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {scheduleLoading ? null : (
          <Box
            sx={{
              position: "relative",
              height: "2.5rem",
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
              "& td": {
                display: "block",
              },
            }}
          >
            <DotPagination
              currPage={page}
              setCurrPage={setPage}
              valueLen={rows?.length}
              valueOnPerPage={rowsPerPage}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                right: "0.5rem",
                transform: "translateY(-50%)",
                // height: "4rem",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <RowsPerPageDropdown
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(e?.target?.value);
                  setPage(0);
                }}
              />
            </Box>
          </Box>
        )}
      </Box>

      <CustomDialog
        open={deleteFileModal.status}
        onClose={() => {
          setDeleteFileModal({ fileId: null, status: false });
        }}
        title="Delete File"
        message="Are you sure you want to delete this file?"
        okLabel="Delete"
        onOk={() => {
          deleteFileHandler(deleteFileModal.fileId);
        }}
      />

      {/* NOTE: delete all dialog modal */}
      <CustomDialog
        open={deleteAllModal.status}
        onClose={() => {
          setDeleteAllModal({ status: false });
        }}
        title="Delete All Files"
        message="Are you sure you want to delete all files?"
        okLabel="Delete All"
        onOk={() => {
          // TODO: delete all files
          setDeleteAllModal({ status: false });
          dispatch(
            deleteAllScheduleFilesAction({
              payload: {
                eventId: eventInfo?._id,
              },
              successCallback: () => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: "All files deleted successfully!",
                  }),
                );
              },
              failureCallback: ({ message }) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Error",
                    message: message || "Failed to delete all files",
                  }),
                );
              },
            }),
          );
        }}
      />
    </Box>
  );
};

ScheduleContent.propTypes = {
  eventInfo: PropTypes.object,
};

const ContentTab = () => {
  const uploadFileRef = React.useRef(null);
  const [totalFiles, setTotalFiles] = React.useState(0);
  const [data, setData] = React.useState([{}]);
  const [currentAcc, setCurrentAcc] = React.useState("acc1");
  const [deleteAllModal, setDeleteAllModal] = React.useState({
    status: false,
  });
  const { userRole } = useSelector((state) => state.auth);
  const { contentResources, contentLoading, eventInfo } = useSelector(
    (state) => state.eventRequestDetails,
  );
  const dispatch = useDispatch();
  const [deleteFileModal, setDeleteFileModal] = React.useState({
    fileId: null,
    status: false,
  });

  React.useEffect(() => {
    setData(contentResources);
  }, [contentResources]);

  const uploadFileHandler = (e) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "video/mp4",
      "audio/mpeg",
      "audio/wav",
      "audio/aac",
      "audio/flac",
      "audio/ogg",
      "audio/m4a",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword",
      "application/pdf",
      "text/plain",
      "image/png",
      "image/jpeg",
    ];
    const files = Array.from(e.target.files);
    if (files?.length > 5) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Warning",
          message: "Please upload at most 5 files!",
        }),
      );
      return;
    }

    // Filter out invalid files and show alert if any invalid files are found
    const invalidFiles = files.filter(
      (file) => !allowedTypes.includes(file.type),
    );
    if (invalidFiles.length > 0) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Invalid File Type",
          message:
            "Please upload only image, video, audio, excel, word, text and pdf files",
        }),
      );
      return; // Stop the function execution if there are invalid files
    }

    setTotalFiles(files.length);
    if (files.length === 0) return;

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
      // const type = file?.type?.split("/")[1];
      // formData.append("type", getMediaType(type));
    });

    dispatch(
      uploadContentResourcesAction({
        payload: {
          formData,
          eventId: eventInfo?._id,
        },
        successCallback: () => {
          if (uploadFileRef.current) {
            uploadFileRef.current.value = "";
          }
        },
        failureCallback: (msg) => {
          if (uploadFileRef.current) {
            uploadFileRef.current.value = "";
          }
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to upload the file.",
            }),
          );
        },
      }),
    );
  };

  // NOTE: download button
  const handleDownloadClick = ({ downloadLink, fileName }) => {
    const anchor = document.createElement("a");
    anchor.href = downloadLink;
    anchor.download = fileName;
    anchor.target = "_blank";
    anchor.click();
  };

  const deleteFileHandler = (fileId) => {
    dispatch(
      deleteContentResourcesAction({
        payload: {
          eventId: eventInfo?._id,
          fileId,
        },
        successCallback: () => {
          setDeleteFileModal({ fileId: null, status: false });
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: "File deleted successfully",
            }),
          );
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: "Failed to delete file",
            }),
          );
        },
      }),
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "20px",
        width: "100%",
        height: "100%",
        position: "relative",
        minHeight: "100px",
      }}
    >
      {contentLoading ? (
        <LoadingOverlay open={contentLoading} />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
            height: "100%",
          }}
        >
          {Object.keys(data).length === 0 && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "#ffffff",
                textAlign: "center",
              }}
            >
              No Files uploaded
            </Typography>
          )}
          {Object.entries(data)?.map(([key, fileList], index) => (
            <FileAccordion
              key={index}
              defaultExpanded={true}
              expanded={currentAcc === `acc${index + 1}`}
              onChange={() => setCurrentAcc(`acc${index + 1}`)}
              odd={index % 2 !== 0}
              summary={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <img
                      src={getLogoForFileType(key)}
                      alt="file icon"
                      style={{ width: "40px", height: "40px" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "24px",
                        fontWeight: "500",
                      }}
                    >
                      {getTitleForFileType(key)}
                    </Typography>
                  </Box>
                </Box>
              }
              details={
                <Box
                  sx={{
                    width: "inherit",
                    backgroundColor: "transparent",
                  }}
                >
                  {fileList?.length === 0 && (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textAlign: "center",
                      }}
                    >
                      No Files uploaded
                    </Typography>
                  )}
                  {fileList?.length > 0 &&
                    fileList?.map((item, key) => (
                      <Box
                        key={key}
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                          border: "1px solid #D175B6",
                          padding: "10px 14px",
                          borderRadius: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "inherit",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <img
                            src={getLogoForFileType(item?.type)}
                            alt="file logo"
                            style={{ width: "40px", height: "40px" }}
                          />
                          <Typography>{item?.fileName}</Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          <Typography
                            sx={{
                              textwrap: "wrap",
                            }}
                          >
                            Added: &nbsp; {/* {formatDate(item?.uploadDate)} */}
                            {getUniversalDateTimeFormat({
                              dateTime: item?.uploadDate,
                            })}
                          </Typography>
                          {uploadAllow(userRole) && (
                            <Button
                              size="small"
                              variant="text"
                              sx={{
                                backgroundColor: "#fff",
                                padding: "10px 10px",
                                width: "auto",
                                minWidth: "auto",
                                ":hover": {
                                  backgroundColor: "#fff",
                                },
                              }}
                              onClick={() => {
                                setDeleteFileModal({
                                  fileId: item?._id,
                                  status: true,
                                });
                              }}
                            >
                              <img src={DeletePink} alt="" />
                            </Button>
                          )}
                          <Button
                            size="small"
                            variant="text"
                            sx={{
                              backgroundColor: "#fff",
                              padding: "10px 10px",
                              width: "auto",
                              minWidth: "auto",
                              ":hover": {
                                backgroundColor: "#fff",
                              },
                            }}
                            onClick={() => {
                              handleDownloadClick({
                                downloadLink: item?.url,
                                fileName: item?.fileName,
                              });
                            }}
                          >
                            <Download
                              sx={{
                                fontSize: "20px",
                              }}
                            />
                          </Button>
                        </Box>
                      </Box>
                    ))}
                </Box>
              }
            />
          ))}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          width: "100%",
          gap: "15px",
        }}
      >
        {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
          <Button
            sx={{
              marginRight: "10px",
              padding: "4px 8px",
              boxShadow:
                " 0px 30px 80px 0px rgba(255, 0, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.6) inset !important",
              position: "relative",
              overflow: "hidden",
            }}
            startIcon={<DeleteForever />}
            type="button"
            onClick={(e) => {
              setDeleteAllModal({ status: true });
            }}
          >
            Delete All
          </Button>
        )}
        {/* TODO: create a upload document button here */}
        {uploadAllow(userRole) && (
          <Button
            sx={{
              marginRight: "10px",
              padding: "4px 8px",
              boxShadow:
                " 0px 30px 80px 0px rgba(255, 0, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.6) inset !important",
              position: "relative",
              overflow: "hidden",
            }}
            startIcon={<UploadFile />}
            type="button"
            onClick={(e) => {
              uploadFileRef.current.click();
              e.stopPropagation();
            }}
          >
            upload file
            <VisuallyHiddenInput
              type="file"
              multiple
              ref={uploadFileRef}
              onChange={uploadFileHandler}
              max={5}
            />
          </Button>
        )}
      </Box>

      <CustomDialog
        open={deleteFileModal.status}
        onClose={() => {
          setDeleteFileModal({ fileId: null, status: false });
        }}
        title="Delete File"
        message="Are you sure you want to delete this file?"
        okLabel="Delete"
        onOk={() => {
          deleteFileHandler(deleteFileModal.fileId);
        }}
      />

      <CustomDialog
        open={deleteAllModal.status}
        onClose={() => {
          setDeleteAllModal({ status: false });
        }}
        title="Delete All Files"
        message="Are you sure you want to delete all files?"
        okLabel="Delete All"
        onOk={() => {
          // TODO: delete all files
          setDeleteAllModal({ status: false });
          dispatch(
            deleteAllContentFilesAction({
              payload: {
                eventId: eventInfo?._id,
              },
              successCallback: () => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: "All files deleted successfully!",
                  }),
                );
              },
              failureCallback: ({ message }) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Error",
                    message: message || "Failed to delete all files",
                  }),
                );
              },
            }),
          );
        }}
      />
    </Box>
  );
};